export const styles = {
  paperItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    width: '100%',
    padding: '0 20px',
    columnGap: '6px',
  },
  itemContentContainer: { display: 'flex' },
  itemContent: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#424550',
    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px !important',
      lineHeight: '146%',
      color: '#23252F',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  redDotContainer: {
    minWidth: '15px',
    height: '20px',
    display: 'flex',
    borderRadius: '4px',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  redDot: {
    width: '6px',
    height: '6px',
    display: 'flex',
    backgroundColor: '#D12D36',
    borderRadius: '50%',
  },
  badgeContainer: (isContentVisible: boolean) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...(isContentVisible && { paddingTop: '20px', marginBottom: '24px' }),
    rowGap: '20px',
    width: '100%',
    maxHeight: '400px',
    overflowY: 'auto',
  }),
};
